import { useEffect, useRef, useState } from 'react';
import './MinMaxOdds.css';
import down_icon from '../../../assets/images/down_icon.svg';
import { OddsKeypad } from './OddsKeypad';

export const MinMaxOddsComponent = (props) => {
	const { filters, setFilters, index, saveUserInfo, email, isArbitrage, isOutliers, forceOpen } = props;
	const [isOpen, setIsOpen] = useState(false);
	const [showMinKeypad, setShowMinKeypad] = useState(false);
	const [showMaxKeypad, setShowMaxKeypad] = useState(false);
	const ref = useRef(null);

	const minOdds = filters?.[index]?.minMaxOdds?.[0] ?? -9999999;
	const maxOdds = filters?.[index]?.minMaxOdds?.[1] ?? 9999999;

	// Open if forceOpen is true
	useEffect(() => {
		if (forceOpen) setIsOpen(true);
	}, [forceOpen]);

	// Close on outside click
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={ref} style={{ height: '140px', position: 'relative' }}>
			<div className="flex flex-row ml-4">
				<div className="flex flex-col" style={{ width: '180px' }}>
					<div style={{ fontSize: '1.25rem', marginBottom: '10px' }}>Min/Max Odds</div>

					<div
						onClick={() => setIsOpen(!isOpen)}
						style={{
							height: '58px',
							width: '100%',
							minWidth: 180,
							backgroundColor: '#17191d',
							border: '2px solid #363844',
							borderRadius: '6px',
							borderBottomLeftRadius: isOpen ? 0 : '6px',
							borderBottomRightRadius: isOpen ? 0 : '6px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							padding: '0 10px',
						}}>
						<div>
							{minOdds === -9999999 ? 'Any' : (minOdds > 0 ? '+' + minOdds : minOdds)} / {maxOdds === 9999999 ? 'Any' : (maxOdds > 0 ? '+' + maxOdds : maxOdds)}
						</div>
						<img
							src={down_icon}
							style={{
								transform: isOpen ? 'rotate(180deg)' : 'none',
								transition: 'transform 0.2s ease-in-out',
							}}
							alt="down arrow"
						/>
					</div>

					{isOpen && (
						<div
							style={{
								position: 'absolute',
								top: '84px',
								left: '1rem',
								zIndex: 10,
								backgroundColor: '#17191d',
								borderRadius: '6px',
								borderTopLeftRadius: 0,
								borderTopRightRadius: 0,
								border: '2px solid #363844',
								borderTop: 'none',
								width: '180px',
							}}
							className="p-3">
							<div className="flex justify-between">
								<div>
									<div className="mb-2">Minimum</div>
									<input
										type="text"
										value={minOdds === -9999999 ? '' : (minOdds > 0 ? '+' + minOdds : minOdds)}
										onChange={(e) => {
											const copy = JSON.parse(JSON.stringify(filters));
											copy[index].minMaxOdds = [Number(e.target.value.replace('+', '')) || -9999999, copy[index].minMaxOdds[1]];
											setFilters(copy);
										}}
										style={{
											width: '70px',
											height: '32px',
											backgroundColor: '#17191d',
											border: '2px solid #363844',
											borderRadius: '6px',
											paddingLeft: '8px',
										}}
										placeholder="Any"
									/>
								</div>
								<div>
									<div className="mb-2">Maximum</div>
									<input
										type="text"
										value={maxOdds === 9999999 ? '' : (maxOdds > 0 ? '+' + maxOdds : maxOdds)}
										onChange={(e) => {
											const copy = JSON.parse(JSON.stringify(filters));
											copy[index].minMaxOdds = [copy[index].minMaxOdds[0], Number(e.target.value.replace('+', '')) || 9999999];
											setFilters(copy);
										}}
										style={{
											width: '70px',
											height: '32px',
											backgroundColor: '#17191d',
											border: '2px solid #363844',
											borderRadius: '6px',
											paddingLeft: '8px',
										}}
										placeholder="Any"
									/>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};